import $ from 'jquery';

$(() => {
    $(".menu__switcher .menu__switcher-item").on('click', (e) => {
        const switcherTarget = $(e.currentTarget).data('target');
        $(".menu__switcher .menu__switcher-item").removeClass('active');
        $(e.currentTarget).addClass('active');

        $(".menu-tab-content").css('display', 'none');
        $("." + switcherTarget).css('display', 'block');
        return false;
    });
});
